
function MeuBPRelatorioHeader({  title, subtitle }) {
    return (
        <div className="p-6 border-b border-border">
            <div className="flex flex-wrap justify-between">
                <div className="flex flex-wrap items-center">
                    <div className="bg-accent p-3 rounded-lg mr-4">
                        <i className="fas fa-file-invoice-dollar text-accent-foreground text-xl"></i>
                    </div>
                    <div>
                        <h2 className="font-display text-xl font-bold text-foreground">{title}</h2>
                        <p className="text-muted-foreground">{subtitle} </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MeuBPRelatorioHeader;